const { expect } = require('chai');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

const projectId = 'migratortron';

describe('Delete content types and components', () => {
  describe('preview deleting a single content type', () => {
    const mock = loadRecordedMock('delete_contenttypes_single_preview.json');

    it(`should return one content type to delete`, (done) => {
      migratortronApi.post(
        'delete/contenttypes?single',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.contentTypes).to.be.an('object');
          expect(body.contentTypes[projectId]).to.be.an('object');
          const contentTypes = body.contentTypes[projectId];
          expect(contentTypes['simpleContentApproval']).to.equal('delete');
          done();
        }
      );
    });
  });

  describe('delete a single content type', () => {
    const mock = loadRecordedMock('delete_contenttypes_commit_single.json');

    it(`should delete one content type successfully`, (done) => {
      migratortronApi.post(
        'delete/contenttypes/commit?single',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.contentTypes).to.be.an('object');
          expect(body.contentTypes[projectId]).to.be.an('object');
          const contentTypes = body.contentTypes[projectId];
          expect(contentTypes['simpleContentApproval']).to.equal('delete');
          done();
        }
      );
    });
  });

  describe('repeat deleting a single content type', () => {
    const mock = loadRecordedMock(
      'delete_contenttypes_commit_single_repeat.json'
    );

    it(`should return an error saying content type is not found`, (done) => {
      migratortronApi.post(
        'delete/contenttypes/commit?single&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body.committed).to.be.true;

          expect(body.contentTypes).to.be.an('object');
          expect(body.contentTypes[projectId]).to.be.an('object');
          const contentTypes = body.contentTypes[projectId];
          expect(contentTypes['simpleContentApproval']).to.equal('error');

          expect(body.errors).to.be.an('array');
          expect(body.errors).to.have.a.lengthOf(1);
          expect(body.errors[0].message).to.contain('not found');

          done();
        }
      );
    });
  });

  describe('preview deleting a single in-use component', () => {
    const mock = loadRecordedMock(
      'delete_components_single_inuse_preview.json'
    );

    it(`should return one component with an error to say in use`, (done) => {
      migratortronApi.post(
        'delete/components?single&inuse',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;

          expect(body.components?.migratortron?.simpleComponent).to.equal(
            'delete'
          );
          expect(body.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('delete a single in-use component', () => {
    const mock = loadRecordedMock('delete_components_commit_single_inuse.json');

    it(`should return one component with an error to say in use`, (done) => {
      migratortronApi.post(
        'delete/components/commit?single&inuse',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          expect(body.committed).to.be.true;
          expect(body.components?.migratortron?.simpleComponent).to.equal(
            'error'
          );
          expect(Array.isArray(body.errors)).to.be.true;
          expect(body.errors.length).to.equal(1);
          expect(body.errors[0].message).to.contain(
            'in use in one or more content types'
          );
          done();
        }
      );
    });
  });

  describe('preview deleting a single unused component', () => {
    const mock = loadRecordedMock(
      'delete_components_single_unused_preview.json'
    );

    it(`should return one component to delete`, (done) => {
      migratortronApi.post(
        'delete/components?single&unused',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.components).to.be.an('object');
          expect(body.components[projectId]).to.be.an('object');
          const components = body.components[projectId];
          expect(components['plainComponent']).to.equal('delete');
          done();
        }
      );
    });
  });

  describe('delete a single unused component', () => {
    const mock = loadRecordedMock(
      'delete_components_commit_single_unused.json'
    );

    it(`should delete one component`, (done) => {
      migratortronApi.post(
        'delete/components/commit?single&unused',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.components).to.be.an('object');
          expect(body.components[projectId]).to.be.an('object');
          const components = body.components[projectId];
          expect(components['plainComponent']).to.equal('delete');
          done();
        }
      );
    });
  });

  describe('repeat the same delete a single unused component', () => {
    const mock = loadRecordedMock(
      'delete_components_commit_single_unused_repeat.json'
    );

    it(`should return an error saying component is not found`, (done) => {
      migratortronApi.post(
        'delete/components/commit?single&unused&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body.committed).to.be.true;

          expect(body.components).to.be.an('object');
          expect(body.components[projectId]).to.be.an('object');
          const components = body.components[projectId];
          expect(components['plainComponent']).to.equal('error');

          expect(body.errors).to.be.an('array');
          expect(body.errors).to.have.a.lengthOf(1);
          expect(body.errors[0].message).to.contain('not found');

          done();
        }
      );
    });
  });

  describe('preview deleting multiple content types and components', () => {
    const mock = loadRecordedMock('delete_contenttypes_multiple_preview.json');

    it(`should return the content types and components to delete`, (done) => {
      migratortronApi.post(
        'delete/contenttypes?multiple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.contentTypes).to.be.an('object');
          expect(body.contentTypes[projectId]).to.be.an('object');
          const contentTypes = body.contentTypes[projectId];
          expect(contentTypes['linkedContent']).to.equal('delete');
          expect(contentTypes['simpleContent']).to.equal('delete');

          expect(body.components).to.be.an('object');
          expect(body.components[projectId]).to.be.an('object');
          const components = body.components[projectId];
          expect(components['linkedComponent']).to.equal('delete');
          expect(components['nestingLinkedComponent']).to.equal('delete');
          expect(components['simpleComponent']).to.equal('delete');
          done();
        }
      );
    });
  });

  describe('delete multiple content types and components', () => {
    const mock = loadRecordedMock('delete_contenttypes_commit_multiple.json');

    it(`should delete the content types and components successfully`, (done) => {
      migratortronApi.post(
        'delete/contenttypes/commit?multiple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.contentTypes).to.be.an('object');
          expect(body.contentTypes[projectId]).to.be.an('object');
          const contentTypes = body.contentTypes[projectId];
          expect(contentTypes['linkedContent']).to.equal('delete');
          expect(contentTypes['simpleContent']).to.equal('delete');

          expect(body.components).to.be.an('object');
          expect(body.components[projectId]).to.be.an('object');
          const components = body.components[projectId];
          expect(components['linkedComponent']).to.equal('delete');
          expect(components['nestingLinkedComponent']).to.equal('delete');
          expect(components['simpleComponent']).to.equal('delete');
          done();
        }
      );
    });
  });

  describe('repeat deleting multiple content types and components', () => {
    const mock = loadRecordedMock(
      'delete_contenttypes_commit_multiple_repeat.json'
    );

    it(`should return an error saying content type is not found`, (done) => {
      migratortronApi.post(
        'delete/contenttypes/commit?multiple&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body.committed).to.be.true;

          expect(body.contentTypes).to.be.an('object');
          expect(body.contentTypes[projectId]).to.be.an('object');
          const contentTypes = body.contentTypes[projectId];
          expect(contentTypes['linkedContent']).to.equal('error');
          expect(contentTypes['simpleContent']).to.equal('error');

          expect(body.components).to.be.an('object');
          expect(body.components[projectId]).to.be.an('object');
          const components = body.components[projectId];
          expect(components['linkedComponent']).to.equal('error');
          expect(components['nestingLinkedComponent']).to.equal('error');
          expect(components['simpleComponent']).to.equal('error');

          expect(body.errors).to.be.an('array');
          expect(body.errors).to.have.a.lengthOf(5);
          expect(
            body.errors
              .map((e) => e.message)
              .every((m) => m.includes('not found'))
          ).to.be.true;

          done();
        }
      );
    });
  });
});
